<template>
  <!-- Sidebar start -->
  <div class="deznav">
    <div class="deznav-scroll">
      <ul class="metismenu" id="menu">
        <li :class="currentPath.includes('wallet') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/monedero" aria-expanded="false">
            <i>
              <svg
                class="mr-0"
                width="68"
                height="68"
                viewBox="0 0 68 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M59.4999 31.688V19.8333C59.4999 19.0818 59.2014 18.3612 58.6701 17.8298C58.1387 17.2985 57.418 17 56.6666 17H11.3333C10.5818 17 9.86114 16.7014 9.32978 16.1701C8.79843 15.6387 8.49992 14.9181 8.49992 14.1666C8.49992 13.4152 8.79843 12.6945 9.32978 12.1632C9.86114 11.6318 10.5818 11.3333 11.3333 11.3333H56.6666C57.418 11.3333 58.1387 11.0348 58.6701 10.5034C59.2014 9.97208 59.4999 9.25141 59.4999 8.49996C59.4999 7.74851 59.2014 7.02784 58.6701 6.49649C58.1387 5.96514 57.418 5.66663 56.6666 5.66663H11.3333C9.07891 5.66663 6.9169 6.56216 5.32284 8.15622C3.72878 9.75028 2.83325 11.9123 2.83325 14.1666V53.8333C2.83325 56.0876 3.72878 58.2496 5.32284 59.8437C6.9169 61.4378 9.07891 62.3333 11.3333 62.3333H56.6666C57.418 62.3333 58.1387 62.0348 58.6701 61.5034C59.2014 60.9721 59.4999 60.2514 59.4999 59.5V47.6453C61.1561 47.0683 62.5917 45.9902 63.6076 44.5605C64.6235 43.1308 65.1693 41.4205 65.1693 39.6666C65.1693 37.9128 64.6235 36.2024 63.6076 34.7727C62.5917 33.3431 61.1561 32.265 59.4999 31.688ZM53.8333 56.6666H11.3333C10.5818 56.6666 9.86114 56.3681 9.32978 55.8368C8.79843 55.3054 8.49992 54.5847 8.49992 53.8333V22.1453C9.40731 22.4809 10.3658 22.6572 11.3333 22.6666H53.8333V31.1666H45.3333C43.0789 31.1666 40.9169 32.0622 39.3228 33.6562C37.7288 35.2503 36.8333 37.4123 36.8333 39.6666C36.8333 41.921 37.7288 44.083 39.3228 45.677C40.9169 47.2711 43.0789 48.1666 45.3333 48.1666H53.8333V56.6666ZM56.6666 42.5H45.3333C44.5818 42.5 43.8611 42.2015 43.3298 41.6701C42.7984 41.1387 42.4999 40.4181 42.4999 39.6666C42.4999 38.9152 42.7984 38.1945 43.3298 37.6632C43.8611 37.1318 44.5818 36.8333 45.3333 36.8333H56.6666C57.418 36.8333 58.1387 37.1318 58.6701 37.6632C59.2014 38.1945 59.4999 38.9152 59.4999 39.6666C59.4999 40.4181 59.2014 41.1387 58.6701 41.6701C58.1387 42.2015 57.418 42.5 56.6666 42.5Z"
                  fill="#7e7e7e"
                />
              </svg>
            </i>
            <span class="nav-text">Monedero</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('recarga-saldo') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/recarga-saldo" aria-expanded="false">
            <i class="flaticon-381-upload-1"></i>
            <span class="nav-text">Recargas</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('transferencia') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/transferencias" aria-expanded="false">
            <i class="flaticon-381-shuffle-1"></i>
            <span class="nav-text">Transferencias</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('retiro-saldo') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/retiro-saldo" aria-expanded="false">
            <i class="flaticon-381-id-card"></i>
            <span class="nav-text">Retiros</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('transacciones') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/transacciones" aria-expanded="false">
            <i class="flaticon-381-notepad"></i>
            <span class="nav-text">Transacciones</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('contrasena') ? 'mm-active' : ''">
          <router-link class="ai-icon" to="/contrasena" aria-expanded="false">
                  <i class="flaticon-381-lock-2"></i>
                  <span class="nav-text">Contraseña</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('perfil-') ? 'mm-active' : ''">
          <router-link class="ai-icon" :to="curUser && curUser.roles.find(o => o.name === 'company') ? '/perfil-empresa' : '/perfil-usuario'" aria-expanded="false">
            <i class="flaticon-381-user-4"></i>
            <span class="nav-text">Perfil</span>
          </router-link>
        </li>
        <li :class="currentPath.includes('faqs') ? 'mm-active' : ''">
          <router-link class="ai-icon" :to="{ name: 'faqs' }" aria-expanded="false">
            <i class="flaticon-381-help-1"></i>
            <span class="nav-text text-justify pr-1">FAQ</span>
          </router-link>
        </li>
        <li>
          <a class="ai-icon" @click="logout" href="javascript:void(0)" aria-expanded="false">
            <i>
              <svg
                id="icon-logout"
                xmlns="http://www.w3.org/2000/svg"
                class="path-hover-none"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
            </i>
            <span class="nav-text">Salir</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <!-- Sidebar end -->
</template>

<style src="@/assets/scss/sidebar.scss" lang='scss' scoped></style>

<script>
import global from "@/helpers/global";

export default {
  mixins: [global],
  mounted() {}
};
</script>
